module.exports = __webpack_public_path__ + "static/img/我的医生.2277ac5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/我的医生.png
// module id = 1320
// module chunks = 358